export default class AppendModal {
  constructor ( param ) {
    this.willOpenCallback= null;
    this.didOpenCallback= null;
    this.willCloseCallback= null;
    this.didCloseCallback= null;
    this.containerClassName= null;
    this.openClassName= null;
    Object.keys(param).forEach(key=> this[key]= param[key]);
  }

  willOpen () {
    this.container= document.createElement("DIV");
    this.container.classList.add(this.containerClassName);
    this.container.classList.add(this.openClassName);
    this.container.addEventListener('animationend', this.aniEndCallback);
    document.body.style.overflowY='hidden';
    this.willOpenCallback && this.willOpenCallback(this);
  }
  
  willClose () {
    document.body.style.overflowY='auto';
    this.container.classList.remove(this.openClassName);
    this.willCloseCallback && this.willCloseCallback(this)
  }

  aniEndCallback= (e)=> {
    if( !e.currentTarget.classList.contains(this.containerClassName) ) return;
    if ( e.currentTarget.classList.contains(this.openClassName) ) this.didOpenCallback && this.didOpenCallback(this);
    if ( !e.currentTarget.classList.contains(this.openClassName) ) 
    {
      this.container.removeEventListener('animationend', this.aniEndCallback);
      this.container.remove();
      this.didCloseCallback && this.didCloseCallback(this);
    }
  }

}